// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3Dzhd","column":"style_column__1fv1m","row":"style_row__1DHgZ"};